import { Navigate, createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { ConnectionsPage, type OAuthResultSearch } from "@/features/marketplace-connections";
import { hasAdminRole, useAuth } from "@/shared/auth";

function MarketplaceConnectionsRoute(): JSX.Element {
  const { user } = useAuth();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Direct-URL guard: the backend requires the admin role on every
  // marketplace-connections endpoint; this only spares a non-admin the
  // flash of a page whose requests will all 403. Same pattern as
  // /audit-log.
  if (!hasAdminRole(user)) {
    return <Navigate to="/" />;
  }
  return (
    <ConnectionsPage
      oauthResult={search}
      onOAuthResultHandled={() => void navigate({ search: {}, replace: true })}
    />
  );
}

export const Route = createFileRoute("/_authenticated/settings/marketplace-connections")({
  validateSearch: (raw: Record<string, unknown>): OAuthResultSearch =>
    raw.status === "success" || raw.status === "error" ? { status: raw.status } : {},
  component: MarketplaceConnectionsRoute,
});
